// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { CostDataUpdateUpload } from '@/costs/components/cost-data-update-upload';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
}

export function CostDataUpdateDialog(props: Props) {
  return (
    <Dialog fullWidth maxWidth="lg" open={props.isOpen} onClose={props.onClose}>
      <DialogTitle>Update cost data</DialogTitle>
      <DialogContent dividers>
        <CostDataUpdateUpload
          onClose={props.onClose}
          onSuccess={props.onSuccess}
        />
      </DialogContent>
    </Dialog>
  );
}
